import { Component, Vue } from 'vue-property-decorator';
import { getDistrictList, getGarden } from 'service/api';

interface LocationItem {
  id: string;
  name: string;
}
interface LocationRes {
  state: boolean;
  data: {
    rows: LocationItem[];
  };
}
interface GardenRes {
  code: number;
  data: {
    rows: LocationItem[];
  };
}
enum LocationVar {
  province = 'provinceList',
  city = 'cityList',
  downtown = 'downtownList',
}

const parentIdName = 'parent_id';

@Component
export default class InitLocation extends Vue {
  provinceList: LocationItem[] = [];

  cityList: LocationItem[] = [];

  downtownList: LocationItem[] = [];

  gardenList: LocationItem[] = [];

  locationObj = {
    garden: '',
    province: '',
    city: '',
    downtown: '',
  }

  get province() {
    return this.locationObj.province;
  }

  set province(val) {
    this.locationObj.province = val;
  }

  get city() {
    return this.locationObj.city;
  }

  set city(val) {
    this.locationObj.city = val;
  }

  get downtown() {
    return this.locationObj.downtown;
  }

  set downtown(val) {
    this.locationObj.downtown = val;
  }

  get garden() {
    return this.locationObj.garden;
  }

  set garden(val) {
    this.locationObj.garden = val;
  }

  // level 表示要获取结果的级别：1-省 2-省，市 3-省，市，区
  level = 3;

  hasGarden = true;

  async initLocation() {
    if (await this.beforeLocationInit()) {
      this.getLocationList();
      let gardenUnit = '';
      if (this.province && this.level > 1) {
        gardenUnit = this.province;
        this.getLocationList(this.province, LocationVar.city);
      }
      if (this.city && this.level > 2) {
        gardenUnit = this.city;
        this.getLocationList(this.city, LocationVar.downtown);
      }
      if (this.downtown) {
        gardenUnit = this.downtown;
      }
      if (gardenUnit && this.hasGarden) {
        this.getGardenList(gardenUnit);
      }
    }
  }

  handleProvinceSelect(val: string) {
    this.city = '';
    this.downtown = '';
    this.garden = '';
    this.downtownList = [];
    if (val && this.level > 1 && val !== '') {
      this.getLocationList(val, LocationVar.city);
      if (this.hasGarden) {
        this.getGardenList(val);
      }
    }
  }

  handleCitySelect(val: string) {
    this.downtown = '';
    this.garden = '';
    if (val && this.level > 2 && val !== '') {
      this.getLocationList(val, LocationVar.downtown);
      if (this.hasGarden) {
        this.getGardenList(val);
      }
    }
  }

  handleDowntownSelect(val: string) {
    this.garden = '';
    if (val && this.hasGarden && val !== '') {
      this.getGardenList(val);
    }
  }

  async getLocationList(id = '0', list: LocationVar = LocationVar.province) {
    if (list === LocationVar.province && this.provinceList.length !== 0) return;
    const res = await getDistrictList({ [parentIdName]: id });
    if ((res as LocationRes).state) {
      this[list] = (res as LocationRes).data.rows.map(item => ({
        id: String(item.id),
        name: item.name,
      }));
    }
  }

  async getGardenList(id: string) {
    const res = await getGarden({ location: id });
    if ((res as GardenRes).code === 200) {
      this.gardenList = (res as GardenRes).data.rows.map(item => ({
        id: item.id,
        name: item.name,
      }));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  beforeLocationInit() {
    return true;
  }
}
